module.exports = __webpack_public_path__ + "static/media/astronaut-fishing.cfe3082f.svg";